import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import { RecurringBillingScheduleSubjectTypeEnum } from "@scrile/api-provider/dist/api/RecurringBillingScheduleProvider";
import { Subject } from "@scrile/api-provider/dist/api/SubjectProvider";
import { Subscription } from "@scrile/api-provider/dist/api/SubscriptionProvider";
import { Transaction } from "@scrile/api-provider/dist/api/TransactionProvider";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";
import SystemIntegration from "./integrations";

export default {
  purchase(pricePackageId: string, price?: string): Promise<Transaction> {
    return new Promise(async (resolve, reject) => {
      const onPurchased = (transaction: Transaction | undefined) => {
        if (!transaction) {
          reject("Transaction not found");
          return;
        }
        emitter.off<Transaction>(EVENTS.PAYMENT_PURCHASED, onPurchased);
        resolve(transaction);
      };
      emitter.emit(EVENTS.PAYMENT_START_PURCHASE, { pricePackageId, price });
      emitter.on<Transaction>(EVENTS.PAYMENT_PURCHASED, onPurchased);
    });
  },

  subscribe(
    subscriptionSubject: Subject<RecurringBillingScheduleSubjectTypeEnum>,
    pricePackageId: string,
    price?: string
  ): Promise<Subscription> {
    return new Promise(async (resolve, reject) => {
      const onSubscribed = (subscription: Subscription | undefined) => {
        if (!subscription) {
          reject("Subscription not found");
          return;
        }
        emitter.off<Subscription>(EVENTS.PAYMENT_SUBSCRIBED, onSubscribed);
        resolve(subscription);
      };
      emitter.emit(EVENTS.PAYMENT_START_PURCHASE, { subscriptionSubject, pricePackageId, price });
      emitter.on<Subscription>(EVENTS.PAYMENT_SUBSCRIBED, onSubscribed);
    });
  },

  checkAllowStoreCard: (system: PaymentSystemPublic) => SystemIntegration(system).allowSaveCard,
};
